var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hide)?_c('v-btn',{attrs:{"icon":_vm.icon,"small":_vm.small,"disabled":_vm.disabled},on:{"click":_vm.print}},[_c('v-icon',[_vm._v("print")]),(_vm.drink === true )?_c('v-icon',[_vm._v("local_bar")]):_vm._e(),(_vm.drink === false )?_c('v-icon',[_vm._v("lunch_dining")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }